import { Component, OnInit, Input } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { DataService } from '../../services/data.service';
import { BaseCheckoutComponent } from '../base-components/base-checkout';
import { pages, WaiverSteps } from '../../alv-enums';
import { ToolsService } from 'src/app/services/tools.service';
import { WaiverService } from 'src/app/services/waiver.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Router } from '@angular/router';
import { TransactionSummary } from 'src/app/models/transaction-summary';
import { FeeDetail } from '../../models/transaction-summary';

@Component({
	selector: 'checkout',
	templateUrl: './checkout.component.html',
	styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent extends BaseCheckoutComponent implements OnInit {

	@Input() public currentPage: pages;

	private apiBaseUrl: string;

	/** This is here to allow the html code to access the pages enum. */
	public pagesEnum: any;
	public feeDetails: any[];

	constructor(public storeService: StoreService
		, dataService: DataService
		, toolsService: ToolsService
		, waiverService : WaiverService
		, protected recaptchaV3Service: ReCaptchaV3Service
		, protected router: Router
	) {		
		super(dataService, storeService, toolsService, waiverService, recaptchaV3Service, router);
		this.pagesEnum = pages;
		this.apiBaseUrl = `${window.location.origin}`;
	}

	async ngOnInit() {
		// Calculate the transaction fees estimate
		this.storeService.shoppingCart.transactionFees = null; // Reset transaction fees

		const cartData = {
			registerId: this.registerId,
			paymentType: null,
			cartSubTotal: this.storeService.shoppingCart.subTotal,  // Get from cart state
			cartTaxTotal: this.storeService.shoppingCart.taxTotal,
			includeTaxInFeeCalculation: true,
			products: this.storeService.shoppingCart.products
		};

		console.log('cartData for fee calculation:', cartData);
		
		const response = await fetch(`${this.apiBaseUrl}/KioskApi/api/ShoppingCart/EstimateTransactionFees`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(cartData)
		});

		const result = await response.json();
		this.storeService.shoppingCart.transactionFees = result.data as TransactionSummary;
		this.feeDetails = result.data.feeDetails as FeeDetail[];

		// Assign the transaction fees to the shopping cart
		this.storeService.shoppingCart.transactionFees = new TransactionSummary({
			baseSubTotal: result.data.baseSubTotal,
			baseTaxTotal: result.data.baseTaxTotal,
			transactionFee: result.data.transactionFee,
			transactionFeeTaxAmount: result.data.transactionFeeTaxAmount,
			subTotal: result.data.subTotal,
			taxTotal: result.data.taxTotal,
			grandTotal: result.data.grandTotal,
			feeDetails: result.data.feeDetails || []
		});

		console.log('Calculated transaction fees:', this.storeService.shoppingCart.transactionFees);
		// -- end calculate
	}

	goToPage(page: pages) {
		const self = this;
		if(self.storeService.kioskSettings.hideInfoStep){
			if(self.storeService.kioskSettings.waiverRequired){
				self.goToPage(pages.Waiver);
				self.waiverService.onStepChangeForward(WaiverSteps.email)
				}
				else
				self.goToPage(pages.Pay)
		}
		else{
			self.pageChange.emit(page);
		}
	}
    resolved(token){
		this.checkoutOrder(token, 2)
	}
}
